import BigNumber from 'bignumber.js';

export function isNumber(str: string | number): boolean {
  if (str === '') {
    return false;
  }

  return !Number.isNaN(Number(str));
}

export function toHumanReadableNumber(
  str: string | number,
  decimal = 18
): number {
  const a = new BigNumber(str);
  const decimalNumber = new BigNumber(10).pow(decimal);
  return Number(a.div(decimalNumber).toFixed(2));
}
